(function () {
  'use strict';
  const configElement = document.getElementById('esl-search-config');
  if (!configElement || !window.ESLSearchCore) return;
  const config = JSON.parse(configElement.textContent);
  const core = window.ESLSearchCore;
  core.configureScopes(config.clauses);
  const strings = config.strings;
  const scopes = ['all', 'bikes', 'scooters', 'parts'];
  const currentURL = new URL(window.location.href);
  const onSearchPage = config.isSearchPage && (!currentURL.searchParams.get('type') || currentURL.searchParams.get('type') === 'product');
  const current = {
    raw: currentURL.searchParams.get('esl_q') || currentURL.searchParams.get('q') || '',
    scope: scopes.includes(currentURL.searchParams.get('esl_scope')) ? currentURL.searchParams.get('esl_scope') : 'all',
    mode: currentURL.searchParams.get('esl_mode') === 'broad' ? 'broad' : 'focused'
  };
  const text = (key, replacements) => {
    let value = strings[key] || key;
    Object.keys(replacements || {}).forEach(name => { value = value.replaceAll('[' + name + ']', replacements[name]); });
    return value;
  };
  const formState = form => ({ scope: form.dataset.eslScope || 'all', mode: form.dataset.eslMode || 'focused' });
  const isProductForm = form => {
    const type = form.getAttribute('data-search-resource-type') || form.querySelector('[name="type"]')?.value;
    return !type || type === 'product';
  };
  const rawTerm = form => (form.querySelector('input[name="q"]')?.value || '').trim();
  function queryFor(raw, state) {
    try { return core.buildQuery(raw, state); } catch (_) { return null; }
  }
  function urlFor(raw, state, page) {
    const query = queryFor(raw, state);
    if (!query) return null;
    const url = new URL(config.searchURL, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'last');
    url.searchParams.set('esl_q', raw);
    url.searchParams.set('esl_scope', state.scope);
    url.searchParams.set('esl_mode', state.mode);
    if (page) url.searchParams.set('page', page);
    if (currentURL.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', currentURL.searchParams.get('preview_theme_id'));
    return url;
  }
  function prepareForms() {
    document.querySelectorAll('.search-form').forEach(form => {
      if (!isProductForm(form)) return;
      const input = form.querySelector('input[name="q"]');
      if (!input) return;
      if (!form.dataset.eslScope) form.dataset.eslScope = onSearchPage ? current.scope : 'all';
      if (!form.dataset.eslMode) form.dataset.eslMode = onSearchPage ? current.mode : 'focused';
      input.maxLength = core.limits.inputLength;
      if (onSearchPage && currentURL.searchParams.has('esl_q') && input.value === (currentURL.searchParams.get('q') || '')) input.value = current.raw;
    });
  }
  function controls(form) {
    const state = formState(form);
    const wrapper = document.createElement('div');
    wrapper.className = 'esl-search-controls';
    const group = document.createElement('div');
    group.className = 'esl-search-scopes';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', strings.productGroup);
    scopes.forEach(scope => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.eslScopeChoice = scope;
      button.className = 'esl-search-scope';
      button.setAttribute('aria-pressed', String(state.scope === scope));
      button.textContent = strings[scope];
      group.appendChild(button);
    });
    wrapper.appendChild(group);
    if (rawTerm(form) && !core.isHelpQuery(rawTerm(form)) && !core.isAdvancedQuery(rawTerm(form))) {
      const row = document.createElement('div');
      row.className = 'esl-search-mode';
      const description = document.createElement('span');
      description.textContent = state.mode === 'broad' ? strings.broadNote : strings.focusedNote;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.dataset.eslModeChoice = state.mode === 'broad' ? 'focused' : 'broad';
      toggle.textContent = state.mode === 'broad' ? strings.useFocused : strings.useBroad;
      row.append(description, toggle);
      wrapper.appendChild(row);
    }
    return wrapper;
  }
  function enhanceResults(form) {
    if (!isProductForm(form)) return;
    const wrapper = form.querySelector('.search__results-wrapper');
    if (!wrapper) return;
    wrapper.querySelectorAll('.esl-search-controls').forEach(element => element.remove());
    if (!form.classList.contains('esl-search-page-form')) wrapper.prepend(controls(form));
    const raw = rawTerm(form);
    const state = formState(form);
    const target = urlFor(raw, state);
    wrapper.querySelectorAll('a.all-results').forEach(link => {
      if (target) link.href = target.href;
      link.textContent = text('viewResults', { query: raw });
    });
    wrapper.querySelectorAll('[data-no-search-results] .no-results').forEach(element => { element.textContent = text('noMatches', { query: raw }); });
    if (wrapper.querySelector('[data-no-search-results]')) {
      const summary = wrapper.querySelector('[data-search-results-summary]');
      if (summary) summary.textContent = text('noMatches', { query: raw });
    }
    const products = wrapper.querySelector('.search__results__products');
    const items = products ? Array.from(products.querySelectorAll('.search__results__item--product')) : [];
    if (items.length) {
      const groups = [[], [], []];
      items.forEach(item => {
        const type = item.dataset.eslProductType;
        const unavailable = item.dataset.eslAvailable === 'false';
        groups[unavailable ? 2 : config.vehicleTypes.includes(type) ? 0 : 1].push(item);
      });
      products.replaceChildren();
      groups.forEach((itemsInGroup, index) => {
        if (!itemsInGroup.length) return;
        const heading = document.createElement('h3');
        heading.className = 'results-heading';
        heading.textContent = [strings.vehicles, strings.parts, strings.unavailable][index] + ' (' + itemsInGroup.length + ')';
        const list = document.createElement('ul');
        itemsInGroup.forEach(item => list.appendChild(item));
        products.append(heading, list);
      });
    }
    rewriteLinks(wrapper);
    if (form.dataset.eslRestoreFocus) {
      const selector = form.dataset.eslRestoreFocus === 'mode' ? '[data-esl-mode-choice]' : '[data-esl-scope-choice="' + state.scope + '"]';
      wrapper.querySelector(selector)?.focus({ preventScroll: true });
      delete form.dataset.eslRestoreFocus;
    }
  }
  function rewriteLinks(root) {
    root.querySelectorAll('a[href]').forEach(link => {
      let url;
      try { url = new URL(link.href, window.location.origin); } catch (_) { return; }
      if (url.origin !== window.location.origin || url.pathname !== new URL(config.searchURL, window.location.origin).pathname) return;
      if (url.searchParams.get('type') && url.searchParams.get('type') !== 'product') return;
      if (onSearchPage && link.closest('.pagination')) {
        const next = urlFor(current.raw, current, url.searchParams.get('page'));
        if (next) link.href = next.href;
      } else if (!url.searchParams.has('esl_q') && url.searchParams.has('q')) {
        const q = url.searchParams.get('q');
        if (core.isAdvancedQuery(q)) return;
        const next = urlFor(q, { scope: 'all', mode: 'focused' });
        if (next) link.href = next.href;
      }
    });
  }
  function preparePage() {
    if (!onSearchPage) return;
    const requested = currentURL.searchParams.get('q');
    if (requested && !core.isAdvancedQuery(current.raw) && queryFor(current.raw, current)) {
      const target = urlFor(current.raw, current, currentURL.searchParams.get('page'));
      if (target && (requested !== target.searchParams.get('q') || !currentURL.searchParams.has('esl_q'))) {
        window.location.replace(target.href);
        return;
      }
    }
    document.querySelectorAll('.esl-search-page-form').forEach(form => {
      form.querySelectorAll(':scope > .esl-search-controls').forEach(element => element.remove());
      form.appendChild(controls(form));
    });
    if (requested) {
      document.querySelectorAll('[data-esl-result-count]').forEach(element => { element.textContent = text('resultCount', { count: config.resultCount, query: current.raw }); });
      document.querySelectorAll('[data-esl-no-matches]').forEach(element => { element.textContent = text('noMatches', { query: current.raw }); });
      document.title = text('pageTitle', { query: current.raw });
    }
    document.querySelectorAll('.esl-search-product-grid').forEach(grid => {
      const cards = Array.from(grid.querySelectorAll(':scope > [data-esl-product-type]'));
      const weight = card => (card.dataset.eslAvailable === 'false' ? 2 : 0) + (config.vehicleTypes.includes(card.dataset.eslProductType) ? 0 : 1);
      cards.sort((a, b) => weight(a) - weight(b)).forEach(card => grid.appendChild(card));
    });
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('.search-form');
    if (!form || !isProductForm(form)) return;
    const input = form.querySelector('input[name="q"]');
    const target = urlFor(rawTerm(form), formState(form));
    event.preventDefault();
    if (target) window.location.assign(target.href);
    else if (input) {
      input.setCustomValidity(strings.refineQuery);
      input.reportValidity();
    }
  }, true);
  document.addEventListener('input', event => {
    if (event.target.matches('.search-form input[name="q"]')) event.target.setCustomValidity('');
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-esl-scope-choice], [data-esl-mode-choice]');
    if (!button) return;
    const form = button.closest('.search-form');
    if (!form) return;
    event.preventDefault();
    if (button.dataset.eslScopeChoice) form.dataset.eslScope = button.dataset.eslScopeChoice;
    if (button.dataset.eslModeChoice) form.dataset.eslMode = button.dataset.eslModeChoice;
    const raw = rawTerm(form);
    if (form.classList.contains('esl-search-page-form')) {
      const target = urlFor(raw, formState(form));
      if (target) window.location.assign(target.href);
      else {
        form.querySelector(':scope > .esl-search-controls')?.replaceWith(controls(form));
        form.querySelector('input[name="q"]')?.focus();
      }
    } else if (window.PXUTheme?.predictiveSearch && window.jQuery) {
      form.dataset.eslRestoreFocus = button.dataset.eslModeChoice ? 'mode' : 'scope';
      window.PXUTheme.predictiveSearch.focusSearchInput(window.jQuery(form), true);
      window.PXUTheme.predictiveSearch.getResults(raw, window.jQuery(form));
    }
  });
  window.ESLSearch = {
    prepareForms,
    enhanceResults,
    requestQuery: (raw, form) => isProductForm(form) ? queryFor(raw, formState(form)) : raw,
    urlFor
  };
  const init = () => { prepareForms(); preparePage(); rewriteLinks(document); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', () => { prepareForms(); rewriteLinks(document); });
}());
